export default __webpack_public_path__ + "static/media/Fatiha.f5a48ab1.mp3";